import React from 'react'
import { FormControl } from 'react-bootstrap'

import QuestionStandardTop from './QuestionStandardTop'

const TextQuestion = ({ question, errors, response, onRespond, validateResponse }) => {
  const outputField = () => {
    const props = {}

    if (question.multiLine) {
      props.componentClass = 'textarea'
    } else {
      props.type = 'text'
    }

    return (
      <FormControl
        key={props.key}
        onChange={t => onRespond(question, t.target.value, false)}
        onBlur={() => validateResponse(question, response)}
        value={response || ''}
        {...props}
        bsClass="text-input form-control"
      />
    )
  }

  return (
    <div key={`inp.questionwrap.${question.id}`}>
      <QuestionStandardTop question={question} />
      {outputField()}
    </div>
  )
}

export default TextQuestion
